// extracted by mini-css-extract-plugin
export default {"statisticshealth":"StatisticsHealth_statisticshealth__DKeuk","container":"StatisticsHealth_container__Ds18k","row":"StatisticsHealth_row__QcaTt"};